import { Body, Box, Heading } from '@hover/blueprint';
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { StaticImage } from 'gatsby-plugin-image';
import PlayIconVector from '../../assets/svgs/PlayIconVector';

const DesignsYouCanEdit = () => {
  const [videoHTML, setVideoHTML] = useState<string | null>(null);

  const VideoWrapper = styled.div`
    width: 100%;
    max-width: 100%;
    display: block;
  `;

  const handleVideoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const htmlText = `<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_ox4ggikir1 playbar=true playerColor=000000 autoPlay=true volumeControl=true endVideoBehavior=loop silentAutoplay=false end" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/ox4ggikir1/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>`;
    setVideoHTML(htmlText);
  };
  return (
    <Box
      px={{ base: 0, tablet: 10 }}
      maxW={{
        base: 'calc(100% - 48px)',
        tablet: 'calc(100% - 32px)',
        desktop: '7xl',
      }}
      w="100%"
      borderRadius={{ base: 0, tablet: 8 }}
      justifyContent="center"
      mt={{ base: 800, tablet: 900, desktop: 1000 }}
      mb={{ base: '48px', tablet: '72px' }}
    >
      <Box
        maxW={{ base: '100%', desktop: '800px' }}
        w="100%"
        justifyContent={{ base: 'flex-start', tablet: 'space-between' }}
        alignItems="center"
        flexDirection="column"
      >
        <Heading
          size={{ base: 500, tablet: 600 }}
          fontWeight={600}
          alignSelf={{ base: 'flex-start', tablet: 'center' }}
        >
          Designs you can edit
        </Heading>
        <Body
          size={{ base: 500, tablet: 600 }}
          maxW={{ base: '100%', tablet: '640px' }}
          textAlign={{ base: 'left', tablet: 'center' }}
          mb={600}
        >
          Design with your customers in real time. Change colors and materials
          on siding, roofing, windows, doors, trim and more without waiting for
          a revision. Selling, and upselling, has never been easier.
        </Body>

        <Box
          width={{ base: '100%', tablet: '800px' }}
          height={{ base: 'auto', tablet: '450px' }}
          borderRadius={8}
          overflow="hidden"
          pos="relative"
        >
          {videoHTML ? (
            <VideoWrapper dangerouslySetInnerHTML={{ __html: videoHTML }} />
          ) : (
            <>
              <Box
                top="50%"
                left="50%"
                position="absolute"
                transform="translate(-50%, -50%)"
                width="100%"
                height="100%"
                justifyContent="center"
                alignItems="center"
                backgroundColor={{ tablet: 'rgba(0, 0, 0, .2)' }}
                zIndex={1}
                cursor="pointer"
                onClick={handleVideoClick}
              >
                <Box alignItems="center" gap={['1rem', '1rem', '0rem']}>
                  <PlayIconVector />
                  <Heading
                    textTransform="uppercase"
                    color="white"
                    ml={[0, 500]}
                    mt={500}
                    mb="0px !important"
                    size={[500, 500, 600]}
                    fontWeight={700}
                    lineHeight={{ base: '30px', tablet: 'inherit' }}
                    letterSpacing={{ base: '6px', tablet: 'initial' }}
                    textAlign="center"
                    maxWidth={['100px', '100px', '250px']}
                  >
                    Play Video
                  </Heading>
                </Box>
              </Box>
              <Box>
                <StaticImage
                  placeholder="blurred"
                  alt="marketing"
                  src="../../../v2/assets/images/design_orders_video_thumb.png"
                />
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DesignsYouCanEdit;
